module.exports = __webpack_public_path__ + "img/premb-r-pm-mobile-1.509eba1b.svg";